function remToPx(rem) {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

class CartFooter extends HTMLElement {
  constructor(){
    super();
    this.cart = this.closest("mass-drawer") || this.closest(".cart__footer-wrapper");
    this.scrollContainer = this.closest(".mass-drawer__wrapper") || window;
    // this.stickyCheckout.position = new Position(this.stickyCheckout, this.scrollContainer);
  }
  findDynamicElements() {
    // alert("finding totalzz..");
    // this.scrollContainer = this.closest(".mass-drawer__wrapper") || window;
    this.checkout = this.querySelector("#checkout");
    this.checkout.position = new Position(this.checkout, this.scrollContainer, remToPx(1));
    this.stickyCheckout = this.cart.querySelector("#checkout-sticky");

    this.stickyTotals = this.cart.querySelector("#sticky-totals");
    this.totals = this.querySelector("#cart-totals");
    this.totals.position = new Position(this.totals, this.scrollContainer, this.checkout.offsetHeight + remToPx(2.6));
  }
  connectedCallback(){
    this.findDynamicElements();
    // this.checkoutHover(this.checkout);
    // this.checkoutHover(this.stickyCheckout);
    this.handleChange();
  }

  handleChange() {
    this.handleScroll();
    this.handleResize();
  }

  handleScroll() {
    this.scrollContainer.addEventListener("scroll", () => {
      // console.log("scrolled");
      this.toggleStickyCheckout();
    });    
  }

  handleResize() {
    window.addEventListener('resize', () => {
      // console.log("===RESIZE EVENT===");
      this.toggleStickyCheckout();
      this.toggleStickyCheckout();
    });
    var ro = new ResizeObserver(entries => {
      for (let entry of entries) {
        this.toggleStickyCheckout();
        this.toggleStickyCheckout();
        console.log(`%c[MassTech / Cart Footer] container resized ${entry.target} ${entry.target.className}`, "color: DarkOrchid")
      }
    });

    if (this.scrollContainer !== window && this.scrollContainer.children) {
      Array.from(this.scrollContainer.children).forEach(childElement => ro.observe(childElement));
    } else if (this.cart) {
      ro.observe(this.cart);
    }
  }

  toggleStickyCheckout() {
    this.checkout.position.update();
    this.totals.position.update();
    this.checkout.position.outOfView ? this.stickyCheckout.classList.remove("hidden") : this.stickyCheckout.classList.add("hidden");
    this.totals.position.outOfView ? this.stickyTotals.classList.remove("hidden") : this.stickyTotals.classList.add("hidden");
    if (this.cart === this.closest("mass-drawer")) this.cart.setSuggestionsBottom();
    
    // console.log("######.2.######");
    // console.log("***totals:***");
    // this.totals.position.print();
    // console.log("*. offsetHeight: " + this.totals.offsetHeight);
    // console.log("*. offTop: " + this.totals.offsetTop);
    // console.log("***STICKY:***");
    // new Position(this..querySelector("#checkout-sticky"), this.scrollContainer).print();
    // console.log("window.pageYOffset: "+window.pageYOffset);
    // console.log("this.scrollContainer.scrollTop " + this.scrollContainer.scrollTop);
    // console.log("window.scrollTop " + window.scrollTop);
  }

  checkoutHover(checkoutButton) {
    // this.checkoutButton = this.querySelector("button[class*='cart__checkout-button button']");
    checkoutButton.initialInnerHTML = checkoutButton.innerHTML;
    checkoutButton.addEventListener("mouseover", () => {
      checkoutButton.innerHTML = "♡ " + checkoutButton.innerHTML + " ♡";
    });
    checkoutButton.addEventListener("mouseout", () => {
      checkoutButton.innerHTML = checkoutButton.initialInnerHTML;
    });
  }

}

customElements.define("cart-footer", CartFooter);
